// @flow
// eslint-disable-next-line no-restricted-imports
import _groupBy from 'lodash';
import { createReducer } from 'redux-act';

import type { SuggestionEventData, List as State } from '../../../types';
import { add, reset } from '../../actions/results';

const initialState: State = [];

function resetHandler(): State {
  return initialState;
}

function addHandler(state: State, suggestions: SuggestionEventData): State {
  // $FlowFixMe[extra-arg]
  const previousSuggestions = _groupBy(suggestions, 'fqdn');
  const newSuggestions = suggestions.filter(suggestion => {
    const previous = previousSuggestions[suggestion.fqdn];
    return !previous || previous.provided !== suggestion.provided;
  });

  if (!newSuggestions.length) {
    return state;
  }

  return newSuggestions.reduce(
    (acc, { fqdn, provided }) => {
      if (previousSuggestions[fqdn]) {
        const idx = acc.findIndex(suggestion => fqdn === suggestion.fqdn);
        acc[idx] = { fqdn, provided };
      } else {
        acc.push({ fqdn, provided });
      }
      return acc;
    },
    [...state],
  );
}

export default (createReducer(
  {
    [reset.toString()]: resetHandler,
    // $FlowFixMe[incompatible-type] TODO: fix type
    [add.toString()]: addHandler,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
